module.exports = __webpack_public_path__ + "img/icon_order_list.be0d0173.png";